export type FormPage = {
    id: string,
    displayName: string
}

export const BASIC_INFORMATION_ID = "BasicInformation";
export const BENEFICIARIES_AT_FIRST_DEATH_ID = "BeneficiariesAtFirstDeath";
export const REMAINDER_BENEFICIARIES_ID = "RemainderBeneficiaries";
export const ADDITIONAL_DISTRIBUTIONS_ID = "AdditionalDistributions";

const FormPages = {
    BASIC_INFORMATION: {
        id: BASIC_INFORMATION_ID,
        displayName: "Basic Information",
    } as FormPage,
    BENEFICIARIES_AT_FIRST_DEATH: {
        id: BENEFICIARIES_AT_FIRST_DEATH_ID,
        displayName: "Beneficiaries at First Death"
    } as FormPage,
    REMAINDER_BENEFICIARIES: {
        id: REMAINDER_BENEFICIARIES_ID,
        displayName: "Remainder Beneficiaries",
    } as FormPage,
    ADDITIONAL_DISTRIBUTIONS: {
        id: ADDITIONAL_DISTRIBUTIONS_ID,
        displayName: "Additional Distributions",
    } as FormPage
}

export default FormPages;